// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import { sync } from 'vuex-router-sync'
import store from '@/store/store'

import Moment from 'vue-moment' ;

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import "vue-multiselect/dist/vue-multiselect.min.css"

import Multiselect from 'vue-multiselect'

import CodeService from "@/services/CodeService" ;
import PlaceService from "@/services/PlaceService" ;

sync(store, router) ;

Vue.config.productionTip = false

Vue.use(Vuetify)

Vue.use(Moment) ;

const Plugin = {
  install (Vue, options) {

    Vue.mixin({
      computed: { 
        /*      
        users () {
          return this.$store.getters.users
        }
        */
      }
    })

    Vue.prototype.$imageBaseURL = process.env.imageBaseURL ;
    Vue.prototype.$apiBaseURL = process.env.apiBaseURL 

    Vue.prototype.$dateFormat = function (d) {
      return this.$moment(d, "DD/MM/YYYY").format("Do MMMM YYYY") ;
    }

    Vue.prototype.$dateFormatFromYMD = function (d) {
      // may be a range - if so contains d1 - d2
      const i = d.indexOf(" - ") ;
      if (i < 0) return this.$moment(d, "YYYY/MM/DD").format("D MMMM YYYY") ;
      else {
        const d1 = d.substring(0, i) ;
        const d2 = d.substring(i + 3) ;
        return this.$moment(d1, "YYYY/MM/DD").format("D MMMM YYYY") + " - " + this.$moment(d2, "YYYY/MM/DD").format("D MMMM YYYY") ;
      }
    }
        
    Vue.prototype.$dateShortFormatFromYMDTHM = function (d) {
      // console.log("date format d=/" + d + "/") ;
      return this.$moment(d, "YYYY-MM-DDTHH:mm").format("D MMM YY") ;
    }

    Vue.prototype.$dateTimeShortFormatFromYMDTHM = function (d) {
      // console.log("date format d=/" + d + "/") ;
      if (d.endsWith("T00:00")) return this.$moment(d, "YYYY-MM-DDTHH:mm").format("D MMM YY") ;  // 15jul20
      else return this.$moment(d, "YYYY-MM-DDTHH:mm").format("D MMM YY HH:mm") ;
    }

    Vue.prototype.$dateTimeFormatFromYMDTHM = function (d) {
      // console.log("date format d=/" + d + "/") ;
      if (d.endsWith("T00:00")) return this.$moment(d, "YYYY-MM-DDTHH:mm").format("D MMMM YYYY") ;  // 15jul20
      else return this.$moment(d, "YYYY-MM-DDTHH:mm").format("D MMMM YYYY HH:mm") ;
    }

    Vue.prototype.$placeSummary = function (place) {
 
      if (!place) return "-" ;

      // create a link to the place, at the lowest level
      var linkId = (place.town) ? place.town.id 
        : ((place.state) ? place.state.id
          : ((place.country) ? place.country.id : null)) ;

      var s = place.town ? place.town.v : "";
      if (place.state) {
        s += (s.length > 1 ? ", " : "") + place.state.v;
      }
      if (place.country) {
        if (place.country.v === "Australia") {
          if (s.length < 1) s = place.country.v;
        } else s += (s.length > 1 ? ", " : "") + place.country.v;
      }

      return ((place.extra) ? (place.extra + ((s.length > 0) ? ", " : "")) : "") + 
        ((linkId) ? ("<a href='/place/" + linkId + "'>" + s + "</a>") : s) ;   
    }

    Vue.prototype.$prettyName = function (name) { // make mixed case

      if (!name) return "" ;
      var parts = name.split(" ") ;
      for (var i = 0 ; i < parts.length ; i++) {
        if (parts[i].length > 1) {
          if ((parts[i].length > 3) && (parts[i].charAt(1) === "'"))
            parts[i] = parts[i].substring(0, 3) + parts[i].substring(3).toLowerCase();
          else parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].substring(1).toLowerCase() ;
          let j = parts[i].indexOf('-') ;
          if ((j > 0) && (j < (parts[i].length - 2))) {  // hypenated
            parts[i] = parts[i].substring(0, j + 1) + parts[i].charAt(j + 1).toUpperCase() +
             parts[i].substring(j + 2) ;
          }
        }
      }
      return parts.join(" ") ;
    } 

    Vue.prototype.$formatScope = function (prop) { // format any scope from and to dates

      if (prop.scopeFrom || prop.scopeTo) return " [" + (prop.scopeFrom ? this.$dateFormatFromYMD(prop.scopeFrom) : "") +
        " - " +  (prop.scopeTo ?  (this.$dateFormatFromYMD(prop.scopeTo)) : "")  + "]" ;
      else return "" ;
    } 
 
    Vue.prototype.$renderSingleValues = function (fld) {  // may be multi or single valued - show all, comma sep

      if (!fld) return "No value recorded" ;
      else if (Array.isArray(fld)) {
        return fld.join(", ") ;
      }
      else return fld ;
    }

    Vue.prototype.$renderStandardListNoLink = function (ele) { // may be an array

      if (!ele) return "No value recorded" ;
      else if (Array.isArray(ele)) {
        var s = "" ;
        for (let i = 0 ; i < ele.length ; i++) 
          s +=  ((i > 0) ? ", " : "") + this.$renderStandardEleNoLink(ele[i]) ;
        return s ;
      }
      else return this.$renderStandardEleNoLink(ele) ;
    }

    Vue.prototype.$renderStandardEleNoLink = function (ele, pathPrefix) {

      return  ele.v ;
    }     

    Vue.prototype.$renderStandardListWithLink = function (ele, pathPrefix) { // may be an array

      if (!ele) return "No value recorded" ;
      else if (Array.isArray(ele)) {
        var s = "" ;
        for (let i = 0 ; i < ele.length ; i++) 
          s +=  ((i > 0) ? "<BR/>" : "") + this.$renderStandardEleWithLink(ele[i]) ;
        return s ;
      }
      else return this.$renderStandardEleWithLink(ele, pathPrefix) ;
    }

    Vue.prototype.$renderStandardEleWithLink = function (ele, pathPrefix) {

      if (ele.type)  return "<a href='/" + pathPrefix + "/" + ele.type + "/" + ele.id + "'>" + ele.v + "</a>" ; 
      return "<a href='/" + pathPrefix + "/" + ele.id + "'>" + ele.v + "</a>" ;      
    } 

    Vue.prototype.$renderCodeListWithLink = function (ele, code, codeName) {

      if (!ele) return "No value recorded" ;
      var s = "" ;
      for (let i = 0 ; i < ele.length ; i++) 
        s +=  ((i > 0) ? "<BR/>" : "") + this.$renderCodeEleWithLink(ele[i], code, codeName) + this.$formatScope(ele[i]) ;
      return s ;
    }

    Vue.prototype.$renderCodeEleWithLink = function (ele, code, codeName) {

      return "<a href='/people?relType=" + code + "&relValue=" + ele.id + "&description=" + encodeURIComponent(codeName) + " of " +
        ele.v + "'>" + ele.v + "</a>" ;        
    } 

    Vue.prototype.$renderSmallImage = function (image) {

      var s = "<a href='" + this.$imageBaseURL + image.filename + "'>" +
        "<img src='" + this.$imageBaseURL + image.filename + "' style='height:200px'/>" +
        "<BR/>" + image.type + "</a>" ;
      if (image.caption) s += "<div>" + image.caption + "</div>" ;      
      if (image.description) s += "<div>" + image.description + "</div>" ;
      if (image.photographer) s += "<div>Photographer: " + image.photographer + "</div>" ;
      return s + "</div>" ;
    }    
    /* replaced with template version
    Vue.prototype.$renderNoks = function (ele) {

      if (!ele) return "" ;
      if (Array.isArray(ele)) {
        var s = "" ;
        for (var nok of ele) s += ((s.length > 0) ? "<BR>" : "") + this.$renderNok(nok) ;
        return s ;
      }
      return this.$renderNok(ele) ;
    }

    Vue.prototype.$renderNok = function (nok) {

      var s = "" ;
      if (nok.role) s += nok.role + ": " ;
      s += this.$prettyName(nok.firstNames) + " " + this.$prettyName(nok.surname) + this.$formatScope(nok) ;
      if (nok.serviceNum) s += " [Service number: " + nok.serviceNum + "]" ;

      if (nok.address) s += ", " + this.$placeSummary(nok.address) ;
      return s ; 
    }
    */

    Vue.prototype.$renderNoksFor = function (ele) {

      if (!ele) return "" ;
      if (Array.isArray(ele)) {
        var s = "" ;
        for (var nokFor of ele) s += ((s.length > 0) ? "<BR>" : "") + this.$renderNokFor(nokFor) ;
        return s ;
      }
      return this.$renderNok(ele) ;
    }

    Vue.prototype.$renderNokFor = function (nokFor) {

      var s = "" ;
      if (nokFor.role) s += nokFor.role + " of: " ;
      s += "<a href='/person/" + nokFor.person.id + "'>" +
        this.$prettyName(nokFor.person.firstNames) + " " + this.$prettyName(nokFor.person.surname) + "</a>" ;
      if (nokFor.person.serviceNum) s += " Service number: " + nokFor.person.serviceNum  ;
      if (nokFor.person.birthDate) s += " Born " + this.$dateFormat(nokFor.person.birthDate) ;
      return s ;
    }  

    Vue.prototype.$navigateTo  = function (route) {
      this.$router.push({name: route})
    }

    Vue.prototype.$renderHeight = function (heightInCm) {   // change to feet and inches to nearest half inch

      const halfInches = heightInCm / 2.54 * 2 ;
      let feet = Math.floor(halfInches / 24) ;
      const remainingHalfInches = Math.round(halfInches - (feet * 24)) ;

      let inch = Math.floor(remainingHalfInches / 2) ;
      const halfInch = (inch * 2) !== remainingHalfInches ;
      if (inch === 12) {  // stop 4' 12"... render as 5'
        feet++ ;
        inch = 0 ;
      }
      var s = "" + feet + "'" ;
      if ((inch > 0) || (halfInch)) s += " " + inch + ((halfInch) ? "½" : "") + '"' ;

      console.log("cm " + heightInCm + " halfInches " + halfInches + " feet " + feet +
        " remainingHalfInces " + remainingHalfInches + " inch " + inch + " halfInch " + halfInch) ;

      return s ;
    }
    Vue.prototype.$renderWeight = function (weightInCentigrams) {   // change to stone and pounds

      const totalPounds = Math.round(weightInCentigrams * 0.220462) ;
      const stone = Math.floor(totalPounds / 14) ;
      const pounds = totalPounds - stone * 14 ;
      return "" + stone + " st" + ((pounds > 0) ? (" " + pounds + " lb") : "") ;
    }    

    Vue.prototype.$decodeNAAseries  = function (seriesId) {

      switch (seriesId) {
        case 'A6769': return 'Service Cards for Navy Officers, 1911-1970' ;
        case 'A6770': return 'Service Cards for Petty Officers and Men, 1911-1970' ;
        case 'A705': return 'Correspondence files, multiple number (Melbourne) series (Primary numbers 1-323)' ;
        case 'A8231': return 'World War II war graves record cards' ;
        case 'A9300': return 'RAAF Officers Personnel files, 1921-1948' ;
        case 'A9301': return 'RAAF Personnel files of Non-Commissioned Officers (NCOs) and other ranks, 1921-1948' ;
        case 'AWM65': return 'RAAF biographical files' ;
        case 'B4747': return 'Army Militia service records, attestation documents (Form A7), alphabetical series' ;
        case 'B883': return 'Second Australian Imperial Force Personnel Dossiers, 1939-1947' ;
        case 'BP751/1': return 'Pay history and allotment cards of discharged RAAF ex-service personnel, single number series' ;
        case 'B884': return 'Citizen Military Forces personnel service records' ;
        default:  return "[unknown series name]" ;
      }
    }

    Vue.prototype.$codeToService = function (code) {
      switch (code) {
        case 'ra': return "Army" ;
        case 'rb': return "RAN" ;
        case 'rc': return "Merchant Navy" ;
        case 'rd': return "RAAF" ;
        default  : return "Unknown: " + code ;        
      }
    }

    Vue.prototype.$serviceToCode = function (service) {
      switch (service) {
        case 'Army': return "ra" ;
        case 'RAN': return "rb" ;
        case 'Merchant Navy': return "rc" ;
        case 'RAAF': return "rd" ;
        default  : return "" ;        
      }    
    }

    Vue.prototype.$renderToastInParent = function (context, message) {

      context.$store.dispatch('setPendingMessage', {text: message, color: 'success'}) ;

      // look for toast

      // first in me and my children, then in my parents and their children

      this.$findToast(context, context) ;
    }

    Vue.prototype.$findToast = function (context, ignoreChild) {

      if (!context) return false ;
      if (context.showAnyToast) {
        context.showAnyToast() ;
        return true ;
      }
      // try children

      if (this.$findToastInChildren(context, ignoreChild)) return true ;

      // nope - try parent and its children (except me)

      return this.$findToast(context.$parent, context) ;
    }
     
    Vue.prototype.$findToastInChildren = function (context, ignoreChild) {

      const children = context.$children ;
      if (!children) return false ;

      for (let i = 0; i < children.length; i++) {
        const c = children[i] ;
        if (c === ignoreChild) continue ;
        if (c.showAnyToast) {
          c.showAnyToast() ;
          return true ;
        }
        if (this.$findToastInChildren(c, ignoreChild)) return true ;
      }
      return false ;
    } ;

    Vue.prototype.$getCodes = async function (force) {

      if (!force && this.$constants.codeValues && (Date.now() - this.$constants.codeLastLookup) < (1000 * 300)) { // no more than 5 min old..
        console.log("constants codeValues exists/current") ;
        return this.$constants.codeValues ;
      }
      console.log("NEED TO FETCH codevalues") ;
      // console.trace() ;
      const codePromise = CodeService.index() ;
      this.$constants.codeValues = (await codePromise).data ;
      this.$constants.codeLastLookup = Date.now() ;
      console.log("codes " + JSON.stringify(this.$constants.codeValues)) ;
      this.$buildDecodedBioEntries(this.$constants.codeValues.b) ;
      return this.$constants.codeValues ; 
    }

    Vue.prototype.$constants = {      
      codes: [
        {code: 'fth', v: 'Religion'}, {code: 'oc', v: 'Occupation'},        
        {code: 'aw', v: 'Honour'}, {code: 'trs', v: 'Transport Vessel'},
        {code: 'b', v: 'Bio entry template'},
        {code: 'dc', v: 'Discharge'}, {code: 'ofc', v: 'Offence'},
        {code: 'mbc', v: 'Medical Board Classification'},  
        {code: 'wnt', v: 'Cause of Wound'}, {code: 'wnp', v: 'Location of Wound '},
        {code: 'ill', v: 'Ailment'}, {code: 'ft', v: 'Fate'}, {code: 'ftp', v: 'Fate post-war'},
        {code: 'ms', v: 'Marital Status'}, {code: 'hc', v: 'Hair Colour'}, {code: 'ge', v: 'Gender'}, {code: 'ec', v: 'Eye Colour'},
        {code: 'jud', v: 'Judicial Authority'}
      ],
      codeValues: null,
      codeLastLookup: 0,
      decodedBioEntries: {},
      bioEntyTemplateSelectors: [],
      enlistedBioEntryId: -1   //  the id of the bioentry template for 'Enlisted' is important - used on peoplesummary to extract enlist date
    } ;

    Vue.prototype.$dayTypes = [
      {value: "tes", text: "Total Effective Service"},
      {value: "wsa", text: "War service in Australia"},
      {value: "aa", text: "Active service in Australia"},
      {value: "ao", text: "Active service outside Australia"},
      {value: "xd", text: "Added days"}
    ] ;

    Vue.prototype.$serviceValues = ['All', 'Army', 'Merchant Navy', 'RAAF', 'RAN'] ;

    Vue.prototype.$globals = {
      lastSearch: {
        surname: '',
        firstNames: '',
        serviceNum: '',
        service: ''}
    };

    Vue.prototype.$setStepPrompt = function (lastFieldPrefix, suffix) {

      if (lastFieldPrefix) return lastFieldPrefix + ((suffix) ? (" " + suffix) : "") ;
      return suffix ;
    }

    Vue.prototype.$buildDecodedBioEntries = function (bioCodes) {

      console.log("IN Vue.prototype.$buildDecodedBioEntries") ;
      const decodes = {} ;
      const templateSelectors = [] ;

      for (const b of bioCodes) {
        const decodedBioTemplateSteps = [] ;
        const v = b.v ;   // (String | ('[' propDescriptor ']')) *
        console.log("Decoding " + v) ;
        if (v.startsWith("Enlisted ")) {
          this.$constants.enlistedBioEntryId = b.id ;
          // console.log("------------------------------------------ Found enlisted " + b.id) ;
        }
        let i = 0 ;

        let lastFieldPrefix = null ;
        let lastSetPrefix = false ;
        while (i < v.length) {
          if (lastSetPrefix) lastSetPrefix = false ;
          else lastFieldPrefix = null ;
          let j = v.indexOf('[', i) ;
          if (j < 0) {  // no more prop descriptors
            let s = v.substring(i).trim() ;
            if (s.length > 0) decodedBioTemplateSteps.push({type: 's', s: s}) ; // a string
            break ;
          }
          if (j > i) {
            let s = v.substring(i, j) ;
            if (s.length > 0) decodedBioTemplateSteps.push({type: 's', s: s}) ; // a string
          }
          i = v.indexOf(']', j + 1) ;
          if (i < (j + 2)) {
            console.log(" ERROR - missing ] in template " + v) ;
            decodedBioTemplateSteps.push({type: 's', s: v.substring(j)}) ; // a string - just use the rest ven though it is invalid
            break ;
          }

          const pr = v.substring(j + 1, i).trim() ;
          // console.log("  i=" + i + " j=" + j + " pr=" + pr + ".") ;

          i++ ; // next loop start point

          if (pr.length < 1) console.log(" ERROR - empty [] in template " + v) ;
          else {  // ok now the hard work...
            if (pr === "place1") decodedBioTemplateSteps.push({type: 'p', prop: 'bp1', prompt: this.$setStepPrompt(lastFieldPrefix, 'Place')}) ;
            else if (pr === "place2") decodedBioTemplateSteps.push({type: 'p', prop: 'bp2', prompt: this.$setStepPrompt(lastFieldPrefix, 'Place')}) ;
            else if (pr === "place3") decodedBioTemplateSteps.push({type: 'p', prop: 'bp3', prompt: this.$setStepPrompt(lastFieldPrefix, 'Place')}) ;
            else if (pr === "rank1") decodedBioTemplateSteps.push({type: 'r', prop: 'br1', prompt: this.$setStepPrompt(lastFieldPrefix, 'Rank')}) ;
            else if (pr === "rank2") decodedBioTemplateSteps.push({type: 'r', prop: 'br2', prompt: this.$setStepPrompt(lastFieldPrefix, 'Rank')}) ;
            else if (pr === "rank3") decodedBioTemplateSteps.push({type: 'r', prop: 'br3', prompt: this.$setStepPrompt(lastFieldPrefix, 'Rank')}) ;   
            else if (pr === "unit1") decodedBioTemplateSteps.push({type: 'u', prop: 'bu1', prompt: this.$setStepPrompt(lastFieldPrefix, 'Unit')}) ;
            else if (pr === "unit2") decodedBioTemplateSteps.push({type: 'u', prop: 'bu2', prompt: this.$setStepPrompt(lastFieldPrefix, 'Unit')}) ;
            else if (pr === "unit3") decodedBioTemplateSteps.push({type: 'u', prop: 'bu3', prompt: this.$setStepPrompt(lastFieldPrefix, 'Unit')}) ;      
            else if (pr === "datetime1") decodedBioTemplateSteps.push({type: 't', prop: 'dt1', prompt: lastFieldPrefix}) ;      
            else if (pr === "datetime2") decodedBioTemplateSteps.push({type: 't', prop: 'dt2', prompt: lastFieldPrefix}) ; 
            else if (pr === "date1") decodedBioTemplateSteps.push({type: 'd', prop: 'd1', prompt: lastFieldPrefix}) ;      
            else if (pr === "date2") decodedBioTemplateSteps.push({type: 'd', prop: 'd2', prompt: lastFieldPrefix}) ;                                   
            else if (pr.startsWith("tx")) {
              let j = pr.indexOf('-') ;
              if (j < 0) {
                console.log(" ERROR - dud text prop number in template " + v) ;
                continue ;
              }
              const prop = pr.substring(0, j).trim() ;
              let k = pr.indexOf('-', j + 1) ; // text field
              if (k < 0) {
                console.log(" ERROR - dud text prop field in template " + v) ;
                continue ;
              }
              const fld = pr.substring(j + 1, k).trim() ;
              const prompt = pr.substring(k + 1).trim() ;
              decodedBioTemplateSteps.push({type: 'x', prop: prop, fld: fld, prompt: prompt}) ;
            }
            else if (pr.startsWith("code-")) {
              let j = pr.indexOf('-', 6) ;
              if (j < 0) {
                console.log(" ERROR - missing code code in template " + v) ;
                continue ;
              }
              const code = pr.substring(5, j).trim() ;
              if (code.length < 1) {
                console.log(" ERROR - dud code code in template " + v) ;
                continue ;
              }
              const fld =  pr.substring(j + 1).trim() ; // json prop
              if (fld.length < 1) {
                console.log(" ERROR - dud code prop field in template " + v) ;
                continue ;
              }
              decodedBioTemplateSteps.push({type: 'c', code: code, fld: fld}) ;
            }  
            else if (pr === 'serviceDays') decodedBioTemplateSteps.push({ type: 'y', prop: 'sdy', fld: 'iv',  prompt: 'Length of service' }) ;
            else if (pr.startsWith("prefix-")) {  //  prefix is conditional display text     
              lastFieldPrefix = pr.substring(7).trim() ; 
              decodedBioTemplateSteps.push({type: ':', conditionalPrefix: lastFieldPrefix}) ;
              console.log(" set lastFieldPrefix to " + lastFieldPrefix) ;
              lastSetPrefix = true ;
            }
          }          
        }
        console.log("  as: " + JSON.stringify(decodedBioTemplateSteps)) ;
        decodes[b.id] = decodedBioTemplateSteps ;

        if (decodedBioTemplateSteps && (decodedBioTemplateSteps.length > 0)) 
          templateSelectors.push({id: b.id, v: decodedBioTemplateSteps[0].s}) ;
      }
      
      this.$constants.decodedBioEntries = decodes ;
      this.$constants.bioEntyTemplateSelectors = templateSelectors ;
    }

    // search related functions
    
    // copy place details from the person record into structure that drives the place selection

    Vue.prototype.$updatePlaceSelectionFromRecord = function (locp, dbp) {

      if (dbp && dbp.rid) {
        locp.select.id = -1 ; 
        if (dbp.town) {
          locp.select.id = dbp.town.id ;
          locp.select.pn = (dbp.town.v) ? dbp.town.v : "" ;
          if (dbp.state && dbp.state.v) locp.select.pn += ", " + dbp.state.v ;
          if (dbp.country && dbp.country.v) locp.select.pn += ", " + dbp.country.v ;
        }
        else if (dbp.state) {
          locp.select.id = dbp.state.id ;
          locp.select.pn = dbp.state.v ;
          if (dbp.country && dbp.country.v) locp.select.pn += ", " + dbp.country.v ;
        }
        else if (dbp.country) {
          locp.select.id = dbp.country.id ;
          locp.select.pn = dbp.country.v ; 
        }
        else {
          locp.select.id = -1 ; 
          locp.select.pn = "" ; 
        }
        locp.origId =  locp.select.id ;
        locp.places = [ locp.select ] ;
        // console.log("Set this.hrp" + JSON.stringify(locp.places)) ;
      }
    } 

    Vue.prototype.$placeQuerySelections = async function (val, locp) {  // returns any error

      if (locp.loading) {
        console.log("PQS in progress - deferring " + val) ;
        locp.pendingSearch = val ;
        return ;
      }

      let searchErr = null ;

      console.log("placeQuerySelections val: " + val) ;
      locp.loading = true ;
      try {
        const response = await PlaceService.placeFindMatchesOnName(val, true, null, locp.placeRelType) ;
        console.log("PlaceService responsed") ; // + JSON.stringify(response)) ;

        locp.places = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        searchErr = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
      }

      if (locp.pendingSearch) {
        const queuedSearch = locp.pendingSearch ;
        locp.pendingSearch = null ;
        console.log("Queuing pending search.." + queuedSearch) ;
        const res = await this.$placeQuerySelections(queuedSearch, locp) ;
        return res ;
      }        
      else return searchErr ;
    }
  }
}

Vue.use(Plugin) ;

Vue.component('multiselect', Multiselect)

Vue.component('user-name', {
  props: ['name'],
  template: '<p>Hi {{ name }}</p>'
}) ;

Vue.component('list-no-links', {
  props: ['fieldToRender', 'field', 'itemTag'],
  template: `
  <div>
  <span v-if='!field'>No value recorded</span>
  <template v-else-if="Array.isArray(field)">
      <item-no-link  v-for="f in field"  v-bind:key="f.id" v-bind:itemTag="itemTag" v-bind:field="f"
        v-bind:fieldToRender="fieldToRender"></item-no-link>
  </template>
  <template v-else> 
    <item-no-link v-bind:field="field" v-bind:fieldToRender="fieldToRender"></item-no-link>
  </template>
  </div>
`
})

Vue.component('item-no-link', {
  props: ['fieldToRender', 'field', 'itemTag'],
  template: `
  <span v-if='itemTag==="span"'>{{ field[fieldToRender] }}</span>
  <div v-else>{{ field[fieldToRender] }}</div>
  `
})

Vue.component('list-with-links', {
  props: ['fieldName', 'field'],
  template: `
  <div>
  <span v-if='!field'>No value recorded</span>
  <template v-else-if="Array.isArray(field)">
      <item-with-link  v-for="f in field"  v-bind:key="f.id" v-bind:field="f"
        v-bind:fieldName="fieldName"></item-with-link>
  </template>
  <template v-else> 
    <item-with-link v-bind:field="field" v-bind:fieldName="fieldName"></item-with-link>
  </template>
  </div>
`
})

Vue.component('item-with-link', {
  props: ['fieldName', 'field'],
  template: `
  <span>
    <router-link v-if="field.type" :to="{path: '/' + fieldName + '/' + field.type + '/' + field.id}">
      {{ field.v }}
    </router-link>
    <router-link v-else :to="{path: '/' + fieldName + '/' + field.id}">
      {{ field.v }}
    </router-link>
  </span>
`
})

Vue.component('rank-with-link', {
  props: ['field'],
  template: `
    <router-link :to="{path: '/rank/' + field.type + '/' + field.id}">
      {{ field.v }}
    </router-link>
`
})

Vue.component('place-summary', {
  props: ['place'],
  computed: {
    genLink () {
      return "/place/" +
        ((this.place.town) ? this.place.town.id 
          : ((this.place.state) ? this.place.state.id
            : ((this.place.country) ? this.place.country.id : null))) ;
    },
    renderPlace () {
      var s = this.place.town ? this.place.town.v : "";
      if (this.place.state) {
        s += (s.length > 1 ? ", " : "") + this.place.state.v;
      }
      if (this.place.country) {
        if (this.place.country.v === "Australia") {
          if (s.length < 1) s = this.place.country.v;
        }
        else s += (s.length > 1 ? ", " : "") + this.place.country.v;
      }
      return s ;
    },
    renderExtra () {
      return this.place.extra + ((this.place.town || this.place.state || this.place.country) ? "," : "") ;
    }
  },
  template: `
  <span>
    <span v-if="!place">-</span>
    <span v-else>
      <span v-if="place.extra">{{renderExtra}} </span>
      <router-link :to="genLink">{{renderPlace}}</router-link>
    </span>
  </span>
  `
})

Vue.component('render-noks', {
  props: ['noks'],
  template: `
  <div>
    <div v-if="Array.isArray(noks)">
      <div v-for="(nok, index) in noks" v-bind:key="index">
        <render-nok v-bind:nok='nok'/>
      </div>
    </div>
    <span v-else><render-nok v-bind:nok='noks'/></span>
  </div>
  `
}) ;

Vue.component('render-nok', {
  props: ['nok'],
  template: `
  <div>
    <span v-if="nok.role">{{nok.role}}: </span>
    {{ $prettyName(nok.firstNames)}} {{$prettyName(nok.surname)}} {{$formatScope(nok)}}
    <span v-if="nok.serviceNum">[Service number: {{nok.serviceNum}}]</span>
    <place-summary v-if="nok.address" v-bind:place="nok.address"></place-summary>
  </div>
  `
}) ;

/* HACK - how to fix so it is parameterised - maybe remove hostname and have ngix sort it out?

Vue.component('small-image', {
  props: ['image'],
  template: `
  <div style='float:left;margin-left:20px'>
    <a v-bind:href='"http://localhost:8081/static/images/" + image.filename'>
      <img v-bind:src='"http://localhost:8081/static/images/" + image.filename' style='height:200px'/>
      <BR/>
      {{image.type}}
    </a>
    <div v-if='image.caption'>{{ image.caption }}</div>    
    <div v-if='image.description'>{{ image.description }}</div>   
  </div>
`
})
*/

Vue.component('provenance-and-note', {

  props: ['record'],
  template: `
  <v-layout row>
    <v-flex xs6>
      <v-textarea v-model="record.provenance" name='provenance' label="Infomation provenance"
        prepend-icon="edit" rows="3" />
    </v-flex>
    <v-flex xs6 ml-2>
      <v-textarea v-model="record.note" name='note' label="Note about this update"
        prepend-icon="edit" rows="3" />            
    </v-flex>
  </v-layout>
`
})

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

/*
  needs to be async...
  console.log("get codes FORCE..") ;
  await Vue.prototype.$getCodes(true) ;
  console.log("... get codes FORCE done") ;
*/

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  dunno: null
})

vm.dunno = "hello" ;

console.log("main js process env is " + JSON.stringify(process.env)) ;



// WEBPACK FOOTER //
// ./src/main.js